// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Success_wrapper__BGDQG {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: calc(100vh - 330px);\n  min-height: 300px;\n  justify-content: center; }\n  .Success_wrapper__BGDQG img {\n    margin-bottom: 62px;\n    width: 129px;\n    height: 128px; }\n  .Success_wrapper__BGDQG p {\n    font-size: 20px;\n    color: black;\n    text-align: center;\n    line-height: 24px; }\n    .Success_wrapper__BGDQG p > span {\n      color: #1890ff;\n      cursor: pointer;\n      font-weight: 500; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "Success_wrapper__BGDQG"
};
module.exports = exports;
